
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class MaterialInBOMGrid extends Serenity.EntityGrid<MaterialInBOMRow, any> {
        protected getColumnsKey() { return 'Purchase.MaterialInBOM'; }
        protected getDialogType() { return MaterialInBOMDialog; }
        protected getIdProperty() { return MaterialInBOMRow.idProperty; }
        protected getInsertPermission() { return MaterialInBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialInBOMRow.localTextPrefix; }
        protected getService() { return MaterialInBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}